// extracted by mini-css-extract-plugin
module.exports = {"container":"_1W1_h","noSpacing":"e0SnY","noSpacingTop":"OEdPW"};